import React, { useEffect, useState } from "react";
// import alertIcon from "../../../images/alert.png";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import { Alert,  DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";
import { getSingleTelnetAction, getSuspensionToggleAction, getTelnetActivityAction, setSuspensionToggleAction, setSuspensionToggleErrorAction } from "../../../store/reducers/adminClientsSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Notification from "../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
interface SuspendPopupProps {
  suspendRec?: string;
  onHide?: () => void;
  clientDetails?:any;
  suspendModalShow: boolean;
  setSuspendModalShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
}

const SuspendPopup: React.FC<SuspendPopupProps> = ({
  onHide,
  suspendModalShow,
  setSuspendModalShow,
  clientDetails
}) => {

  const dispatch = useDispatch();
  const classes = useStyles();

const { isClientSuspensionResponse, isClientSuspensionError } = useSelector(
  (state: any) => state?.adminClients
);

  const submitHandler = () => {
    const payload = {
      tenantId: clientDetails?.client_id,
      isSuspended: clientDetails?.is_suspended ? false : true,
      status:clientDetails?.is_suspended ? "ACTIVE" : 'SUSPENDED'
    };
    console.log("payload", { ...payload });
    dispatch(getSuspensionToggleAction({ ...payload }));
  };

  useEffect(()=>{
    if(isClientSuspensionResponse){
      dispatch(getSingleTelnetAction(clientDetails?.client_id));
      dispatch(getTelnetActivityAction(clientDetails?.client_id));
      setSuspendModalShow(false);
      dispatch(setSuspensionToggleAction(false));
    }
  },[isClientSuspensionResponse])

  const closeModel = () => {
    setSuspendModalShow(false);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    dispatch(setSuspensionToggleErrorAction(false));
  };

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition
  return (
    <Popup
      open={suspendModalShow}
      title={"Confirm Suspension"}
      onHide={closeModel}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
         
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
         {isClientSuspensionError ? (
            <CustomButton variant="outlined" title="Close" onClick={closeModel} />
          ) : (
            <>
              <CustomButton variant="outlined" title="No" onClick={onHide} />
              <CustomButton title="Yes" onClick={submitHandler} />
            </>
          )}
        </>
      }
    >
      <DialogContent sx={{padding:'0px'}}>
        <DialogContentText >
          <>
            {/* <img src={alertIcon} alt="icons" /> */}
            {isClientSuspensionError ? (
              <Notification />
            ) : (
              <Alert sx={{ bgcolor: "#eeecef", fontSize: "16px" }} severity="warning">
                Are you sure you want to suspend this client?
              </Alert>
            )}
          </>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default SuspendPopup;
